import { ProductPrices, PromoCode } from '@/network/graphql.g'
import { FC, createContext, useState } from 'react'

type PromoCodesContextProps = {
  promoCodes: PromoCode[]
  prices: ProductPrices
}

type PromoCodesContextType = {
  isOpenModal: boolean
  handleOpenModal: () => void
  handleCloseModal: () => void
}

const PromoCodesContext =
  createContext<PromoCodesContextType & PromoCodesContextProps>(null)

export const PromoCodesProvider: FC<PromoCodesContextProps> = ({
  children,
  promoCodes,
  prices
}) => {
  const [isOpenModal, setOpenModal] = useState(false)
  const handleOpenModal = () => setOpenModal(true)
  const handleCloseModal = () => setOpenModal(false)

  const value = {
    promoCodes,
    prices,
    isOpenModal,
    handleOpenModal,
    handleCloseModal
  }
  return (
    <PromoCodesContext.Provider value={value}>
      {children}
    </PromoCodesContext.Provider>
  )
}
